import SockJS from 'sockjs-client'
import EventBus from '@/components/EventBus'
import Service from '@/request/base'

export default function createWebSocketPlugin () {
    return store => {
        store.subscribe((mutation, state) => {
            if (mutation.type === 'updateUser') {
                let ws = state.ws
                let closeWindow = false
                if (!state.user || !state.user.username) {
                    store.commit('setWs', null)
                    return
                }
                if (ws) {
                    return
                }
                ws = new SockJS(Service.url('/sockjs/websocket') + '?username=' + state.user.username)
                ws.open = function () {
                    console.log('open websocket')
                }
                ws.onclose = function () {
                    console.log('close websocket')
                    store.commit('setWs', null)
                    if (closeWindow) {
                        return
                    }
                    ws = new SockJS(Service.url('/sockjs/websocket') + '?username=' + state.user.username)
                }
                ws.onmessage = function (e) {
                    EventBus.$emit('websocket-message', e.data)
                }
                store.commit('setWs', ws)
                // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = function () {
                    closeWindow = true
                    if (state.ws) {
                        state.ws.close()
                        store.commit('setWs', null)
                    }
                }
            }
        })
    }
}
